(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxSubscription(
    $timeout, $filter, toastr, $http, STRIPE_PUBLISHABLE_KEY, COUNTRIES_RESOURCES,
    JsVatFactory, RegexModel, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        tenant: '=tenant',
        me: '=me',
        billingData: '=billingData',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/subscription/subscription/subscription.template.html',
      link: function(scope) {

        scope.requireVAT = false;
        scope.billingDataMinimumRequirement = false;
        scope.updatingCreditcard = false;
        scope.clientSecret = null;
        scope.cardError = null;

        scope.showCcs = false;
        scope.showCcs_pristine = true;
        scope.showInvoiceRefs = false;
        scope.showInvoiceRefs_pristine = true;
        scope.regex = new RegexModel();

        scope.gettingBillingData = true;

        scope.termsAndConditions = {
          accepted: false
        };
        scope.formDebounceTime = 1000;
        scope.editMode = '';

        scope.cardIncomplete = true;
        scope.cardError = false;
        scope.editCreditCard = false;


        (function() {
          scope.billingDataOriginal =  angular.copy(scope.billingData);
          formatBillingData();
          populateCountriesList();
        })();

        function getBillingData () {
          var url = scope.tenant.info._links['px:billingData'].href;
          scope.gettingBillingData = true;
          $http.get(url).then(function(response) {
            scope.billingData = response.data;
            scope.billingDataOriginal =  angular.copy(response.data);

            formatBillingData();
          }).catch(function(error){});
        }

        function formatBillingData () {
          splitCompanyAddressString(scope.billingData);
          splitCustomersRefString(scope.billingData)
          scope.requireVAT = checkIfVATisRequired(scope.billingData.countryCode);
          billingDataMinimumRequirement();
          if (!scope.billingData.creditCardLast4) {
            setupSTRIPECardForm();
          } else {
            scope.editCreditCard = false;
            checkExpirationDate()
          }
          scope.editMode = '';
          scope.updatingBillingData = false;
          scope.gettingBillingData = false;
        }

        function checkExpirationDate () {
          var d = new Date();
          var year = d.getFullYear();
          var month = d.getMonth() +1;
          var currentDate = parseInt('' + year + month);



          if (currentDate > scope.billingData.creditCardExpiry) {
            scope.creditCardExpired = true;
          }
        }

        function hackBillingData (billingData) {
          billingData.companyName = null;
          billingData.companyAddress = '';
          billingData.contactEmail = null;
          billingData.contactName = null;
          billingData.countryCode = null;
          billingData.corporateIdentificationNumber = null;
          billingData.customersRefs = null;
          billingData.creditCardLast4 = null;

          return billingData
        }

        function splitCompanyAddressString (billingData) {

          var companyAddress = {}
          var companyAddressSplit = billingData.companyAddress ? billingData.companyAddress.split('\n') : null;

          companyAddress['address_0'] = companyAddressSplit ? companyAddressSplit[0] : null;
          companyAddress['address_1'] = companyAddressSplit ? companyAddressSplit[1] : null;
          companyAddress['address_2'] = companyAddressSplit ? companyAddressSplit[2] : null;
          companyAddress['address_3'] = companyAddressSplit ? companyAddressSplit[3] : null;
          companyAddress['address_4'] = companyAddressSplit ? companyAddressSplit[4] : null;

          scope.companyAddress = companyAddress;
        }

        function splitCustomersRefString (billingData) {
          var customersRefs = {}
          var customersRefsSplit = billingData.customersRefs ? billingData.customersRefs.split('\n') : null;

          customersRefs['ref_0'] = customersRefsSplit ? customersRefsSplit[0] : null;
          customersRefs['ref_1'] = customersRefsSplit ? customersRefsSplit[1] : null;
          customersRefs['ref_2'] = customersRefsSplit ? customersRefsSplit[2] : null;

          scope.customersRefs = customersRefs;
        }

        function checkIfVATisRequired (countryCode) { // USE .find()

          var euCountryCodes = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'GR', 'ES', 'FI', 'FR', 'GB', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SL', 'SK'];
          var requireVAT = false
          for (var i = 0; i < euCountryCodes.length; i++) {
            if (euCountryCodes[i] === countryCode && scope.billingData.corporateIdentificationNumber) {
              requireVAT = true;
              break;
            }
          }
          return requireVAT;
        }

        function billingDataMinimumRequirement () {
          var requiredBillingDataKeys = {
            contactEmail: 'contactEmail',
            countryCode: 'countryCode',
            companyName: 'companyName',
            contactName: 'contactName',
            companyAddress: 'companyAddress',
          }
          scope.billingDataMinimumRequirement = true;
          for (var key in requiredBillingDataKeys) {
            if (!scope.billingData[key]) {
              scope.billingDataMinimumRequirement = false;
              break
            }
          }
        }

        scope.setCountry = function(country) {
          scope.requireVAT = checkIfVATisRequired(country.id);
          if (country.id !== scope.billingData.countryCode) {
            scope.billingData.corporateIdentificationNumber = null;
          }
          scope.billingData.countryCode = country.id;
        }

        function populateCountriesList () {
          $http.get(COUNTRIES_RESOURCES.COUNTRIES, {
            cache: true
          }).then(function(response) {
            scope.selectCountryDataObject = {
              listRaw: response.data,
              placeholderText: 'Select',
            };
          }).catch(function(error){});
        }

        scope.findCountryInList = function (countryList, selectedCountry) {
          for (var i = 0; i < countryList.length; i++) {
            if (countryList[i].id === selectedCountry) {
              return countryList[i];
            }
          }
          return null;
        }

        scope.toogleInvoiceRefs = function () {
          scope.showInvoiceRefs_pristine = false;
          scope.showInvoiceRefs = !scope.showInvoiceRefs;
        }

        function toogleCcs () {
          scope.showCcs_pristine = false;
          scope.showCcs = !scope.showCcs;
          if (!scope.billingData.ccs) {
            scope.billingData.ccs = [''];
          } else if (Array.isArray(scope.billingData.ccs) && scope.billingData.ccs.length === 0) {
            scope.billingData.ccs = [''];
          }
        }

        scope.addNewFinanceEmail = function () {
          if (!scope.billingData.ccs) {
            scope.billingData.ccs = [''];
          } else {
            scope.billingData.ccs.push('');
          }
        }

        scope.setFormScope = function(this_scope) {
          $timeout(function() {
            scope.billingForm = this_scope.billingForm;
          }, 1)
        }



        scope.validateVAT = function() {
          scope.checkingVAT = true;
          scope.requireVAT = checkIfVATisRequired (scope.billingData.countryCode);

          if(scope.requireVAT && scope.billingData.corporateIdentificationNumber && scope.billingForm) {

            var VAT = null;
            if (scope.billingData.countryCode === 'GR') {
              VAT = JsVatFactory.checkVAT('EL' + scope.billingData.corporateIdentificationNumber);
            } else {
              VAT = JsVatFactory.checkVAT(scope.billingData.countryCode+scope.billingData.corporateIdentificationNumber);
            }

            if (VAT && !VAT.isValid) {
              scope.billingForm.form_corporateIdentificationNumber.$invalid = true;
              scope.billingForm.$invalid = true;
            } else {
              scope.billingForm.form_corporateIdentificationNumber.$invalid = false;
            }

          } else {
            if (scope.billingForm) {
              scope.billingForm.form_corporateIdentificationNumber.$invalid = false;
            }
          }
        }

        scope.saveBillingData = function () {
          scope.updatingBillingData = true;
          scope.billingData.customersRefs = mapCustomersRefsToBillingDataCustomersRefs();
          scope.billingData.companyAddress = mapCompanyAddressToBillingDataCompanyAddress();
          scope.editMode = '';
          removeEmptyStrings();
          scope.tenant.changeBillingData(scope.billingDataOriginal, scope.billingData).then(function(billingData) {
            scope.updatingBillingData = false;

            if (billingData) {
              toastr.success($filter("translate")("ChangesSaved"));
            } else {
              getBillingData();
            }
          }).catch(function(error){
            toastr.error($filter("translate")("ERROR"));
            scope.updatingBillingData = false;
          });
        }

        function mapCustomersRefsToBillingDataCustomersRefs () {
          var customersRefs = '';
          var int = 0;
          for (var key in scope.customersRefs) {
            if (scope.customersRefs[key]) {
              if (int < 2) {
                customersRefs = customersRefs + scope.customersRefs[key] + '\n'
              } else {
                customersRefs += scope.customersRefs[key]
              }
            }
            int += 1;
          }

          return customersRefs;
        }

        function mapCompanyAddressToBillingDataCompanyAddress () {
          var companyAddress = '';
          var int = 0;
          for (var key in scope.companyAddress) {
            if (scope.companyAddress[key]) {
              if (int < 4) {
                companyAddress = companyAddress + scope.companyAddress[key] + '\n'
              } else {
                companyAddress += scope.companyAddress[key]
              }
            }
            int += 1;
          }

          return companyAddress;
        }

        function removeEmptyStrings () {
          if (scope.billingData.ccs) {
            for (var i = 0; i < scope.billingData.ccs.length; i++) {
              if (scope.billingData.ccs[i] === '') {
                scope.billingData.ccs.splice(i, 1);
                i--;
              }
            }
          }
        }

        scope.fixVatNumber = function (caption) {
          return $filter('translate')(caption).split('(')[0];
        }

        scope.toggleEditMode = function (mode) {
          if (mode ===  'emailMode') {
            toogleCcs()
          }
          scope.editMode = mode;
        }

        scope.cancelEdit = function () {
          scope.editMode = '';
          scope.billingData = angular.copy(scope.billingDataOriginal);
          formatBillingData();
        }


        ////////////////////////////////////
        ///// STRIPE STUFF
        ////////////////////////////////////
        function setupSTRIPECardForm() {
          getClientSecret();
          var stripe = Stripe(STRIPE_PUBLISHABLE_KEY);
          var elements = stripe.elements();


          var style = {
            base: {
              border: '1px solid #cccccc',
              fontSmoothing: 'antialiased',
              fontSize: '16px',
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a'
            }
          };

          var card = elements.create('card', {style: style});

          $timeout(function (){
            card.mount('#card-element');
            submitCardListener(stripe, card);
          }, 50)

          card.addEventListener('change', function(event) {
            var displayError = document.getElementById('card-errors');
            if (event.error) {
              displayError.textContent = event.error.message;
              scope.cardError = true;
            } else {
              displayError.textContent = '';
              scope.cardError = false;
            }

            if (!event.complete) {
              scope.cardIncomplete = true;
            } else {
              scope.cardIncomplete = false;
            }
          });
        }

        scope.getBillingDataCardExpiryData = function () {
          var billingDataCardExpiryDataMonth = scope.billingData.creditCardExpiry.toString().slice(4, 6);
          var billingDataCardExpiryDataYear = scope.billingData.creditCardExpiry.toString().slice(0, 4);
          return billingDataCardExpiryDataMonth + ' / ' + billingDataCardExpiryDataYear;
        }

        scope.toggleCreditCard = function () {
          scope.editCreditCard = !scope.editCreditCard;
          if (scope.editCreditCard) {
            setupSTRIPECardForm();
          }
        }

        function submitCardListener (stripe, cardForm) {
          var card = cardForm;
          $timeout(function() {
            var form = document.getElementById('payment-form');
            form.addEventListener('submit', function(event) {
              scope.updatingCreditcard = true;
              event.preventDefault();

              stripe.handleCardSetup(
                scope.clientSecret,
                card
              ).then(function(result) {
                if (result.error) {
                  scope.updatingCreditcard = false;
                  toastr.error($filter("translate")(result.error.message));
                  scope.cardError = result.error.message;
                } else {
                  scope.tenant.sendStripePaymentMethodId(result.setupIntent.payment_method, scope.billingData).then(function(response) {

                    scope.updatingCreditcard = false;
                    getBillingData()
                    toastr.success($filter("translate")("ChangesSaved"));
                  }).catch(function(error){
                    scope.updatingCreditcard = false;
                    getBillingData()
                    toastr.error($filter("translate")("ERROR"));
                  });
                }
              }).catch(function(error){});
            });
          }, 50)
        }

        function getClientSecret () {
          scope.tenant.getClientSecret(scope.billingData).then(function(response){
            scope.clientSecret = response.data.clientSecret;
          }).catch(function(error){});
        };

        var BILLING_DATA_UPDATED_listener = $rootScope.$on('UPDATE_BILLING_DATA', function(name, data) {
          scope.billingData = data.data;
          scope.billingDataOriginal =  angular.copy(data.data);
          formatBillingData();
        });

        scope.$on('$destroy', function() {
          BILLING_DATA_UPDATED_listener();
        });


      }
    };
  }

  pxSubscription.$inject = [
    '$timeout', '$filter', 'toastr', '$http', 'STRIPE_PUBLISHABLE_KEY', 'COUNTRIES_RESOURCES',
    'JsVatFactory', 'RegexModel',  '$rootScope'
  ];

  angular
    .module('printix-admin')
    .directive('pxSubscription', pxSubscription);

})();
